import "./wizard.less";

import {t} from "@lingui/core/macro";
import * as React from "react";

import {useOnMountEffect} from "@khanacademy/wonder-blocks-core";
import {usePublishAnalyticsEvent} from "@khan/analytics-learning-time";

export default function KnownStudent(): React.ReactElement {
    const publishAnalyticsEvent = usePublishAnalyticsEvent();

    useOnMountEffect(() => {
        publishAnalyticsEvent({
            eventType: "AiGuideTeacherFeaturesKnownStudentPageViewed",
            eventSchemaVersion: 1,
        });
    });

    return (
        <div className="wizard-view">
            <div className="container">
                <h1 className="sad-path-heading">
                    {t`Students are not eligible at this time.`}
                </h1>
                <p>
                    {t`Khanmigo for teachers is available only to teachers at this time. Check with your teacher or district administrator if you are interested in using Khanmigo as a student.`}
                </p>
            </div>
        </div>
    );
}
